module.exports = __webpack_public_path__ + "static/media/aeps-card.23d0d17a.png";